<template>
<div>

 <!-- start company info header -->
  
  <div style="margin-bottom:90px" @click="goToEntity()">
 	<card style="" >
 		<div style="padding-bottom:10px;">
   		<div style="font-weight:bold;font-size:24px"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp; </span> {{coy.uen}}</div>
   		</div>
    </card>
  </div>
  
  <!-- end company info header -->
  
  
    <div class="col-md-12">
    
    	<div>
			<h4 class="title">{{taskDisplayInfo.task_header}}</h4>
			<div style="margin-bottom:30px" class="">
				{{taskDisplayInfo.task_subheader}}
			 </div>
        </div>
    
        
      <!-- end: header-->
        
      <!-- start: change address-->  
      <card v-if="taskNameSys=='ch_address'">
      
      
			<form class="form-horizontal"  @submit.prevent="submitResolutionDetails">
          <h4 slot="header" class="card-title">
           1) New Company Address
          </h4>
          <div class="row">
            <label class="col-md-3 col-form-label">New Address</label>
            <div class="col-md-9">
              <fg-input v-model="form.new_address" placeholder="" ></fg-input>
            </div>
          </div>

          <div slot="footer" class="row">
            <label class="col-md-3"></label>
            <div class="col-md-9">

               
              
            </div>
          </div>
        </form>

       
      </card> <!-- end card -->
      
       <!-- start: share transaction-->  
      <card v-if="taskNameSys=='st'">
      
      
			<form class="form-horizontal"  @submit.prevent="submitResolutionDetails">
          <h4 slot="header" class="card-title">
           1) New Share Transaction
          </h4>
          <div class="row">
            <label class="col-md-3 col-form-label">Shareholder Name</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.name" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Share Type</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.share_type" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Number of Shares</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.num_shares" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Transaction Type</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.transaction_type" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Paid-Up Capital</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.paid_up_capital" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
          
          

          <div slot="footer" class="row">
            <label class="col-md-3"></label>
            <div class="col-md-9">

               
              
            </div>
          </div>
        </form>

       
      </card> <!-- end card -->
      
       <!-- start: share transaction: Share transfer-->  
      <card v-if="taskNameSys=='stt'">
      
      
			<form class="form-horizontal"  @submit.prevent="submitResolutionDetails">
          <h4 slot="header" class="card-title">
           1) New Share Transfer
          </h4>
          <div class="row">
            <label class="col-md-3 col-form-label">Shareholder Name</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.name" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Share Type</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.share_type" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Number of Shares</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.num_shares" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Transaction Type</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.transaction_type_str" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
           <div class="row">
            <label class="col-md-3 col-form-label">Paid-Up Capital</label>
            <div class="col-md-9">
              <fg-input v-model="taskStInfo.paid_up_capital" placeholder=""  disabled></fg-input>
            </div>
          </div>
          
          
          

          <div slot="footer" class="row">
            <label class="col-md-3"></label>
            <div class="col-md-9">

               
              
            </div>
          </div>
        </form>

       
      </card> <!-- end card -->
      
       <!-- start: officer change-->  
      <card v-if="taskNameSys=='oc'">
      
      
          <h4 slot="header" class="card-title">
           1) Changes For Officer:  {{taskOcInfo.officer_name_str}}
          </h4>
		  <div style='font-size:14px;margin-left:10px;margin-bottom:20px;color:#000;'>
          	 New Status:  <span style="font-weight:bold;"> {{taskOcInfo.new_officer_status_str}} </span>
		  </div>

       
      </card> <!-- end card -->
      
      
      
      
         <!-- start: share cert-->  
      <card v-if="taskNameSys=='sc'">
      
      
          <h4 slot="header" class="card-title">
           1) New Share Certificate Number:  {{taskScInfo.cert_number}}
          </h4>
		  <div style='font-size:14px;margin-left:10px;margin-bottom:20px;color:#000;'>
          {{taskScInfo.num_shares}}  {{taskScInfo.share_type_str}} Shares For  {{taskScInfo.shareholder_name_str}}
		  </div>

       
      </card> <!-- end card -->
      
      
         <!-- start: cancel share cert-->  
      <card v-if="taskNameSys=='scc'">
      
      
          <h4 slot="header" class="card-title">
           1) Cancel Share Certificate No:  {{taskScInfo.cert_number}}
          </h4>
		  <div style='font-size:14px;margin-left:10px;margin-bottom:20px;color:#000;'>
          {{taskScInfo.num_shares}}  {{taskScInfo.share_type_str}} Shares For  {{taskScInfo.shareholder_name_str}}
		  </div>

       
      </card> <!-- end card -->
      
      
       <card>
         <h4 slot="header" class="card-title">
           2) Who Should Sign?
          </h4>
          
          <div v-for="officer in coy.officers" >
          	
          	<p-checkbox style="margin-bottom:15px;margin-top:15px;" :id="officer.id" :value="officer.id" 
          	 v-model="selectedOfficers['o'+officer.id]">
          		<span style="color:#000">{{officer.person.first_name}} {{officer.person.last_name}} ({{officer.pivot.position}}) </span>
          		<span v-if="officer.email" style="color:#000">- {{officer.person.email}}</span>
          		</p-checkbox>
          </div>
       
       </card><!-- end card -->
      
      
      <card>
         <h4 slot="header" class="card-title">
           3) Document Generation
          </h4>
          
          <div  v-if="main_document.id" style="margin:20px 0px">
          <p-button   @click="viewDocumentPdf(0)" type="default">View Existing Document</p-button>
      
		   </div>
          
          <p-button v-if="displayGenPdfButton"  @click="submitResolutionDetails()" native-type="submit"  type="warning" >{{submitResolutionButtonText}}</p-button>
          
          
           <p-button v-if="pdf_path" @click="viewPdf()" type="success">View New Document</p-button>
           
           <div style="margin-bottom:50px;"> 
           		<p-button v-if="pdf_path" outline  round  @click="saveTask()" type="default">Save Task & Document Without Sending Document For Signing</p-button>
           </div>
           
     </card>

      <div class="card" style="display:none;"><!-- to delete? -->
        <div class="card-header">
          <h4 class="card-title">4) Send Document For Signing</h4>
        </div>
        <div class="card-body">
        	
        	 <p-button @click="sendForSigning()" type="info">Send For Signing</p-button>
        	 <div style="margin:50px 0px;font-weight:bold;font-size:20px">
        	 Signing Status:<span> {{signing_status}}</span>
        	 </div>
        	 
        	     <p-button   @click="viewDocumentPdf(1)" type="default">View Signed Document</p-button>
          		 <p-button   @click="viewDocumentPdf(2)" type="default">View Signing Log</p-button>
          		 <p-button   @click="refreshStatus()" type="warning">Refresh Status</p-button>
          
          
        </div>
      </div>  <!-- end card -->
    </div> <!-- end col-md-12 -->
    
    <!--
    <div style="text-align:center;margin-bottom:200px;"> <p-button @click="saveTask()" style="width:300px;">Save</p-button></div>
  	-->
  </div>
  
</template>
<script>
 import { Card } from 'src/components/UIComponents'
 import ApiService from 'src/services/api.service'
 import swal from 'sweetalert2'

  export default {
    components: {
      Card
    },
    mounted() {
    
    
    	
    
    
    	this.taskNameSys = this.$route.params.taskname;
    	
    	if(this.taskNameSys == "ch_address"){
    		this.taskDisplayInfo.task_header = 'Task: Resolution For Change In Company Address';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get the resolution signed.';
    	}
    	else if(this.taskNameSys == "st"){
    		this.taskDisplayInfo.task_header = 'Task: Resolution For Share Transaction';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get the resolution signed.';
    	}
    	else if(this.taskNameSys == "stt"){
    		this.taskDisplayInfo.task_header = 'Task: Resolution For Share Transfer';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get the resolution signed.';
    	}
    	
    	else if(this.taskNameSys == "sc"){
    		this.taskDisplayInfo.task_header = 'Task: Create Share Certificate';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get the share certificate signed.';
    		
    		this.submitResolutionButtonText = "Click To Generate Share Certificate";
    	}
    	else if(this.taskNameSys == "scc"){
    		this.taskDisplayInfo.task_header = 'Task: Cancel Share Certificate';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get resolution signed.';
    		
    	}
    	else if(this.taskNameSys == "oc"){
    		this.taskDisplayInfo.task_header = 'Task: Officer Change';
    		this.taskDisplayInfo.task_subheader = 'Fill in the necessary information and get resolution signed.';
    		
    	}
    	
    	
    
      	 let uri = this.$base_url+'/api/v1/tasks/details/'+ this.$route.params.eid+"/"+this.$route.params.taskname 
      	 					+"/"+this.$route.params.cid+"/" + this.$route.params.tid + "/" +  this.$route.params.type;
     	 ApiService.get(uri).then(response => {
      	
         	this.coy = response.data.entity;
         	this.documents = response.data.documents;
         	
         	
         	if(this.main_document.signing_status != null){
				this.main_document = response.data.main_document;
			
				if(this.main_document.signing_status == "vi"){
					this.signing_status = "Viewed By Signers";
				}
				else if(this.main_document.signing_status == "se"){
					this.signing_status = "Sent For Signing";
				}
				else if(this.main_document.signing_status == "si"){
					this.signing_status = "Signing Complete";
				}
         	}
         	
         	const vm = this;
         	response.data.entity.officers.forEach(function(officer){
         		
         		vm.selectedOfficers["o"+officer.id] = false;
         	});
         	
         	
         	if(this.taskNameSys == "st"){
         		this.taskStInfo = response.data.child;
         		let st_ = response.data.child;
         		this.taskStInfo.name = st_.shareholder.person.first_name + " "+ st_.shareholder.person.last_name;
         		if(st_.transaction_type == 1){
         			this.taskStInfo.transaction_type = "Increase";
         		}
         		else if(st_.transaction_type == 2){
         			this.taskStInfo.transaction_type = "Decrease";
         		}
         		else if(st_.transaction_type == 1){
         			this.taskStInfo.transaction_type = "Share Transfer";
         		}
         		
         	}//end if taskNameSys ==st
         	else if(this.taskNameSys == "stt"){
         		this.taskStInfo = response.data.child;
         		let st_ = response.data.child;
         		this.taskStInfo.name = st_.shareholder.person.first_name + " "+ st_.shareholder.person.last_name;
         		
         		if(st_.transaction_type == 4){
         			
         		}
         	
         	}
		 	else if(this.taskNameSys == "sc"){
		 		if(this.$route.params.tid != 0){
		 			this.displayGenPdfButton = false;
		 		}
		 		
		 		this.taskScInfo = response.data.child;
		 	}
		 	else if(this.taskNameSys == "scc"){
		 		if(this.$route.params.tid != 0){
		 			this.displayGenPdfButton = false;
		 		}
		 		
		 		this.taskScInfo = response.data.child;
		 	}
		 	else if(this.taskNameSys == "oc"){
		 		this.taskOcInfo = response.data.child;
		 		
		 	
		 	}
         	
      	})//end repsonse
    },
    methods: {
    	refreshStatus(){
    		//start testing
    	
			let uri2 = this.$base_url+'/api/v1/entities/test3';
				ApiService.post(uri2, {
					"tid":this.$route.params.tid
				}).then(response => {
							
					
					
			})
			
			//end testing	 
    	
    	},
    	viewDocumentPdf(type){
    		this.$router.push( '/view-document/'+this.main_document.id+"/"+type);
    	},
    	viewExistingPdf(){
    		this.$router.push( '/view-document/'+this.main_document.id+"/0");
    	},
    	viewSignedPdf(){
    		
    		this.$router.push( '/view-document/'+this.main_document.id+"/1");
    	},
    	goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	    },

    	viewPdf(){
    		//alert("PDF path:"+ this.pdf_path)
    		window.open(this.pdf_path, "_blank");  
    	},
    	submitResolutionDetails(){
    		//this.main_document = null;
    		
			const vm = this;
			vm.selectedOfficersArr = []
			
			var off = this.coy.officers;
			off.forEach(function(t){
				if(vm.selectedOfficers["o"+t.id]==true){
					vm.selectedOfficersArr.push(t.id);
				}
			});
			
			//return;
    	
    		let uri = this.$base_url+'/api/v1/documents/resolution';
      		ApiService.post(uri, {
    			 "new_address":this.form.new_address,
    			 "entity_id": this.$route.params.eid,
    			 "officers":this.selectedOfficersArr,
    			 "rType": this.taskNameSys,
    			 "cid": this.$route.params.cid,
    			 "type": this.$route.params.type
    			 
    		}).then(response => {
      				
      				swal({
						  title: 'Done!',
						  text: 'The document has been successfully generated. You may send the document for signing.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
					})
         			//alert("Document generated at: "+response.data.document_path)
         		
         			this.pdf_path = response.data.document_path;
         			this.cert_num = response.data.cert_num;
     		 })
    	},
    	sendForSigning(){
    		let uri = this.$base_url+'/api/v1/documents/send_signing';
      		ApiService.post(uri, {
    			"pdf_path":this.pdf_path,
    			"tid": this.$route.params.tid,
    		}).then(response => {
      	
         			//alert("document generated at: "+response)
         			this.sentStatus = 1;
         			this.signing_status = "Document sent to signee for signing";
         			this.saveTask();
         			
         			
         			
         			
     		 })

    	},
    	
    	saveTask(){
    		let save_msg = "The document has been successfully sent for signing and this task has been saved."
    		
    		if(this.sentStatus==0){
    			save_msg = "This task has been successfully saved."
    		}
    	
    		let uri = this.$base_url+'/api/v1/tasks';
    		let task_type = null;
    		let task_name = "";
    		let task_name_sys = "";
    		let task_status = 2;
    		
    		
    		if(this.taskNameSys == "ch_address"){
    			task_type = 2;
    			task_name = "Change In Company Address";
    			task_name_sys = "ch_address";
    		}
    		else if(this.taskNameSys == "oc"){
    			task_type = 2;
    			task_name = "Officer Change";
    			task_name_sys = "oc";
    		}
    		else if(this.taskNameSys == "st"){
    			task_type = 2;
    			task_name = "Share Transaction";
    			task_name_sys = "st";
    		}
    		else if(this.taskNameSys == "stt"){
    			task_type = 2;
    			task_name = "Share Transfer";
    			task_name_sys = "stt";
    		}
    		else if(this.taskNameSys == "sc"){
    			task_type = 2;
    			task_name = "Share Certificate";
    			task_name_sys = "sc";
    		}
    		else if(this.taskNameSys == "scc"){
    			task_type = 2;
    			task_name = "Cancel Share Certificate";
    			task_name_sys = "scc";
    		}
    		
    	
    		
    		if(this.sentStatus == 1){
    			task_status = 2;
    		}
    		else{
    			task_status = 1;
    		}

    		
    		
					ApiService.post(uri, {
						 "pdf_path":this.pdf_path,
						 "cert_num":this.cert_num,
						 "entity_id": this.$route.params.eid,
						 "task_type": task_type,
						 "task_name": task_name,
						 "task_name_sys": task_name_sys,
						 "task_status":task_status,
						 "cid":this.$route.params.cid,
						 "type":this.$route.params.type,
						 "task_id":this.$route.params.tid,
				 
					}).then(response => {
					
							swal({
								  title: 'Done!',
								  text: save_msg,
								  type: 'success',
								  confirmButtonClass: 'btn btn-success btn-fill',
								  buttonsStyling: false
							})
				
					 })//end post
    	
    	
    	}//end saveTask()
    	
    	
    },
    data() {
      return {
      	submitResolutionButtonText : "Click To Generate New Resolution",
        coy:[],
        taskDisplayInfo:[{
        	'task_header':'',
        	'task_subheader':'',
        }],
        taskOcInfo:[{
        	'officer_name_str':'',
        	'new_officer_status_str':''
        }],
        taskStInfo:[{
        	'name':'',
        	'share_type':'',
        	'num_shares':'',
        	'transaction_type':'',
        	'paid_up_capital':''
        }],
        taskScInfo:[{
        	'cert_number':'',
        	'share_type':'',
        	'num_shares':'',

        }],
        sentStatus:0,
        cert_num:0,
        displayGenPdfButton: true,
        taskNameSys:'',
        selectedOfficersArr:[],
        selectedOfficers:[],
        documents:[],
        main_document:[],
        pdf_path:'',
        signing_status:'Not Available',
        form:{
        	new_address:''
      	}
      }
    }
  }
</script>

